(function () {
  'use strict';

  var screenSteps = {
    organization: 1,
    administrator: 2,
    program: 3,
    bulk: 4,
    premium: 4,
    plan: 4,
    checkout: 5,
    provisioning: 5,
    ready: 5,
    'premium-ready': 5,
    'existing-essential': 5
  };

  var stepLabels = ['Organization', 'Contact', 'Account Use', 'Plan', 'Finish'];
  var planLabels = {
    starter: 'Starter · $0/month',
    essential: 'Essential · $20/month',
    school: 'Schools & Teams · $0/month'
  };
  var purposeLabels = {
    event_bulk: 'Event or Bulk Order',
    team_gear: 'Staff, Team, or Volunteer Gear',
    spirit_wear: 'Spirit Wear',
    participant_rewards: 'Gifts and Participant Rewards'
  };
  var organizationSizeLabels = {
    lt25: 'Under 25 people',
    '25-100': '25–100 people',
    '100-500': '100–500 people',
    '500plus': '500+ people',
    unsure: 'Not sure yet'
  };
  function checkedValue(scope, name) {
    var checked = scope.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : '';
  }

  function init(root) {
    if (!root || root.dataset.suReady === 'true') return;
    root.dataset.suReady = 'true';

    var apiBase = (root.dataset.suApiBase || '').replace(/\/$/, '');
    var signupEnvironment = root.dataset.suEnvironment === 'live' ? 'live' : 'sandbox';
    var storageKey = 'pyc-account-signup-state-v2:' + signupEnvironment;

    var state = {
      signupRequestId: '',
      bulkRequestId: '',
      premiumRequestId: '',
      organizationType: '',
      organizationName: '',
      organizationSize: '',
      firstName: '',
      lastName: '',
      email: '',
      purpose: '',
      needBy: '',
      bulkDescription: '',
      premiumDescription: '',
      premiumIntent: false,
      plan: 'starter',
      termsAccepted: false,
      paymentConfirmed: false,
      provisionStage: 0
    };
    var timers = [];
    var pendingHubSpotIdentity = null;
    var identifiedHubSpotRequests = {};
    var pendingMicrosoftSignup = null;
    var reportedMicrosoftSignups = {};
    var screens = Array.prototype.slice.call(root.querySelectorAll('[data-su-screen]'));
    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-su-nav]'));
    var progress = root.querySelector('[data-su-progress]');
    var progressFill = root.querySelector('[data-su-progress-fill]');

    function createSignupRequestId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }

    function saveState() {
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {}
    }

    function restoreState(attemptId) {
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        if (saved && typeof saved === 'object' && saved.signupRequestId === attemptId) {
          Object.assign(state, saved);
          return true;
        }
      } catch (error) {}
      return false;
    }

    function clearSavedState() {
      try { window.sessionStorage.removeItem(storageKey); } catch (error) {}
    }

    function setPaymentStatus(message, isError) {
      var status = root.querySelector('[data-su-payment-status]');
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    function setSignupStatus(message, isError) {
      var status = root.querySelector('[data-su-signup-status]');
      if (!status) return;
      status.hidden = !message;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function setPremiumStatus(message, isError) {
      var status = root.querySelector('[data-su-premium-status]');
      if (!status) return;
      status.hidden = !message;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }

    function clearTimers() {
      timers.forEach(function (timer) { window.clearTimeout(timer); });
      timers = [];
    }

    function shuffleChoiceSet(selector) {
      var grid = root.querySelector(selector);
      if (!grid) return;
      var choices = Array.prototype.slice.call(grid.children).filter(function (child) {
        return child.matches('label');
      });
      for (var index = choices.length - 1; index > 0; index -= 1) {
        var randomIndex = Math.floor(Math.random() * (index + 1));
        var current = choices[index];
        choices[index] = choices[randomIndex];
        choices[randomIndex] = current;
      }
      choices.forEach(function (choice) { grid.appendChild(choice); });
    }

    function shuffleChoiceSets() {
      shuffleChoiceSet('[data-su-organization-types]');
      shuffleChoiceSet('[data-su-primary-uses]');
    }

    function businessToday() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { values[part.type] = part.value; });
      return values.year + '-' + values.month + '-' + values.day;
    }

    function configureNeedByDate(clearValue) {
      var input = root.querySelector('input[name="need_by"]');
      if (!input) return;
      input.min = businessToday();
      input.required = !state.premiumIntent;
      root.querySelector('[data-su-need-by-label]').textContent = state.premiumIntent
        ? 'When do you need it by? (optional)'
        : 'When do you need it by?';
      if (clearValue) input.value = '';
    }

    function requireCurrentNeedByDate() {
      configureNeedByDate(false);
      var input = root.querySelector('input[name="need_by"]');
      if (state.premiumIntent && !state.needBy) return true;
      if (state.needBy && input && state.needBy >= input.min) return true;
      if (input) {
        input.value = state.needBy || '';
        showScreen('program');
        input.reportValidity();
      }
      return false;
    }

    function hubSpotTrackingAllowed() {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        return signupEnvironment === 'live' && privacy &&
          typeof privacy.analyticsProcessingAllowed === 'function' &&
          typeof privacy.marketingAllowed === 'function' &&
          privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
      } catch (error) { return false; }
    }

    function identifyAcceptedSignupInHubSpot() {
      var identity = pendingHubSpotIdentity;
      if (!identity || !identity.requestId || !identity.email) return;
      var key = 'pyc-account-signup-hubspot-identify-v1:' + identity.requestId;
      if (identifiedHubSpotRequests[key]) return;
      if (!hubSpotTrackingAllowed()) return;
      try { if (window.localStorage.getItem(key) === 'sent') return; } catch (error) {}
      try {
        window._hsq = window._hsq || [];
        if (typeof window._hsq.push !== 'function') return;
        window._hsq.push(['identify', { email: identity.email }]);
        window._hsq.push(['trackPageView']);
        identifiedHubSpotRequests[key] = true;
        try { window.localStorage.setItem(key, 'sent'); } catch (error) {}
        pendingHubSpotIdentity = null;
      } catch (error) {
        // Attribution must never prevent signup or payment.
      }
    }

    function queueAcceptedSignupForHubSpot(requestId) {
      pendingHubSpotIdentity = { requestId: requestId, email: state.email };
      identifyAcceptedSignupInHubSpot();
    }

    function loadTrackingPermissions() {
      document.addEventListener('visitorConsentCollected', identifyAcceptedSignupInHubSpot);
      document.addEventListener('visitorConsentCollected', reportAcceptedSignupToMicrosoft);
      try {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) {
            identifyAcceptedSignupInHubSpot();
            reportAcceptedSignupToMicrosoft();
          }
        });
      } catch (error) {
        // Missing privacy support must not block signup or assume consent.
      }
    }

    function showScreen(name, quiet) {
      clearTimers();
      if (name === 'program') configureNeedByDate(false);
      screens.forEach(function (screen) {
        var active = screen.dataset.suScreen === name;
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
      });

      var step = screenSteps[name] || 1;
      progress.setAttribute('aria-valuenow', String(step * 20));
      progressFill.style.width = (step * 20) + '%';
      root.querySelector('[data-su-step-number]').textContent = String(step);
      root.querySelector('[data-su-step-label]').textContent = name === 'bulk' ? 'Bulk request' : (name === 'premium' ? 'Premium request' : stepLabels[step - 1]);
      root.querySelector('[data-su-nav-four-label]').textContent = name === 'bulk' || state.premiumIntent ? 'Request' : 'Plan';
      navItems.forEach(function (item) {
        var itemStep = Number(item.dataset.suNav);
        item.classList.toggle('is-current', itemStep === step);
        item.classList.toggle('is-complete', itemStep < step);
        item.querySelector('span').textContent = itemStep < step ? '✓' : String(itemStep);
      });
      var activeHeading = root.querySelector('[data-su-screen="' + name + '"] h2');
      if (!quiet) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          if (activeHeading) activeHeading.focus({ preventScroll: true });
        }, 260);
      }
    }

    function setPlan(value) {
      var radio = root.querySelector('input[name="plan"][value="' + value + '"]');
      if (radio) radio.checked = true;
      state.plan = value;
      var continueButton = root.querySelector('[data-su-plan-continue]');
      if (continueButton) {
        continueButton.firstChild.nodeValue = value === 'essential' ? 'Continue to payment ' : 'Confirm signup ';
      }
      var planConsent = root.querySelector('[data-su-plan-consent]');
      var planTerms = root.querySelector('input[name="plan_terms"]');
      var needsPlanConsent = value !== 'essential';
      if (planConsent) planConsent.hidden = !needsPlanConsent;
      if (planTerms) {
        planTerms.disabled = !needsPlanConsent;
        planTerms.required = needsPlanConsent;
      }
    }

    function configurePlans() {
      var type = state.organizationType;
      var schoolsTeamsPlan = type === 'school' || type === 'sports';
      var starter = root.querySelector('[data-su-plan="starter"]');
      var essential = root.querySelector('[data-su-plan="essential"]');
      var school = root.querySelector('[data-su-plan="school"]');

      starter.hidden = schoolsTeamsPlan;
      essential.hidden = schoolsTeamsPlan;
      school.hidden = !schoolsTeamsPlan;

      root.querySelector('[data-su-plan-eyebrow]').textContent = schoolsTeamsPlan ? 'Your included plan' : 'Choose your plan';
      root.querySelector('[data-su-plan-heading]').textContent = schoolsTeamsPlan ? 'Start with Schools & Teams.' : 'Choose how you want to start.';
      root.querySelector('[data-su-plan-lead]').textContent = schoolsTeamsPlan
        ? 'There is no monthly plan fee. Merchandise, decoration, shipping, and applicable tax are billed separately.'
        : 'Merchandise, decoration, shipping, and applicable tax are separate from the monthly plan price.';

      if (schoolsTeamsPlan) {
        setPlan('school');
      } else if (!['starter', 'essential'].includes(state.plan)) {
        setPlan('starter');
      }
    }

    function setPremiumIntent(value) {
      state.premiumIntent = value === true;
      root.querySelector('[data-su-brand-copy]').textContent = state.premiumIntent ? 'Premium consultation' : 'Account signup';
      root.querySelector('[data-su-sidebar-eyebrow]').textContent = state.premiumIntent ? 'Premium consultation' : 'Account signup';
      root.querySelector('[data-su-sidebar-heading]').textContent = state.premiumIntent ? 'Let’s talk Premium.' : 'Let’s get you started.';
      root.querySelector('[data-su-sidebar-copy]').textContent = state.premiumIntent
        ? 'Tell us about your organization and what you hope to build.'
        : 'First a few questions about your organization.';
      configureNeedByDate(false);
    }

    function applyInboundIntent() {
      var goal = '';
      var requestedPlan = '';
      try {
        var search = new URLSearchParams(window.location.search);
        goal = search.get('goal') || '';
        requestedPlan = search.get('plan') || '';
      } catch (error) {}
      if (goal !== 'premium' && (requestedPlan === 'starter' || requestedPlan === 'essential')) {
        setPlan(requestedPlan);
      }
      setPremiumIntent(goal === 'premium' && signupEnvironment === 'live');
      var note = root.querySelector('[data-su-intent-note]');
      var heading = root.querySelector('[data-su-org-heading]');
      var lead = root.querySelector('[data-su-org-lead]');
      var bulkContract = root.querySelector('[data-su-bulk-contract]');
      note.hidden = true;
      note.textContent = '';
      heading.textContent = 'Tell us about your organization.';
      lead.textContent = '';
      lead.hidden = true;
      bulkContract.hidden = true;

      if (goal === 'bulk') {
        heading.textContent = 'What kind of organization is this order for?';
        lead.textContent = 'Tell us who the order supports, then we’ll route it without creating an unnecessary account.';
        lead.hidden = false;
        bulkContract.hidden = false;
      } else if (goal === 'premium' && signupEnvironment === 'live') {
        lead.textContent = 'Share a few details so we can discuss the right Premium setup with you.';
        lead.hidden = false;
      } else {
        return;
      }

      note.textContent = '';
    }

    function prepareProvisioning() {
      clearTimers();
      state.provisionStage = 0;
      var list = root.querySelector('[data-su-provision-list]');
      Array.prototype.forEach.call(list.children, function (item) {
        item.classList.remove('is-active', 'is-done');
        item.querySelector('span').textContent = '○';
      });
      root.querySelector('[data-su-provision-title]').textContent = 'See what happens after signup.';
      root.querySelector('[data-su-payment-task]').textContent = state.plan === 'essential' ? 'Payment confirmed by Stripe' : 'No subscription payment required';
      var accountName = state.plan === 'essential' ? 'Essential' : (state.plan === 'school' ? 'Schools & Teams' : 'Starter');
      root.querySelector('[data-su-account-task]').textContent = 'Create ' + accountName + ' account in Fulfill Engine';
      root.querySelector('[data-su-delay]').hidden = true;
      root.querySelector('[data-su-verified]').hidden = true;
      root.querySelector('[data-su-provision-actions]').hidden = false;
    }

    function markProvisionItem(index, className, icon) {
      var item = root.querySelector('[data-su-provision-list]').children[index];
      if (!item) return;
      item.classList.remove('is-active', 'is-done');
      item.classList.add(className);
      item.querySelector('span').textContent = icon;
    }

    function runProvisioning() {
      clearTimers();
      root.querySelector('[data-su-delay]').hidden = true;
      root.querySelector('[data-su-provision-actions]').hidden = true;
      root.querySelector('[data-su-verified]').hidden = true;
      root.querySelector('[data-su-provision-title]').textContent = 'Setting up the account safely…';
      var count = root.querySelector('[data-su-provision-list]').children.length;
      var start = state.provisionStage;

      for (var index = start; index < count; index += 1) {
        (function (currentIndex) {
          timers.push(window.setTimeout(function () {
            if (currentIndex > 0) markProvisionItem(currentIndex - 1, 'is-done', '✓');
            markProvisionItem(currentIndex, 'is-active', '…');
            state.provisionStage = currentIndex;
          }, (currentIndex - start) * 620));
        })(index);
      }

      timers.push(window.setTimeout(function () {
        markProvisionItem(count - 1, 'is-done', '✓');
        state.provisionStage = count;
        root.querySelector('[data-su-provision-title]').textContent = 'Your account workspace is ready.';
        root.querySelector('[data-su-verified]').hidden = false;
      }, (count - start) * 620 + 300));
    }

    function showDelay() {
      clearTimers();
      state.provisionStage = Math.max(1, state.provisionStage);
      markProvisionItem(0, 'is-done', '✓');
      markProvisionItem(1, 'is-active', '…');
      root.querySelector('[data-su-provision-title]').textContent = 'Setup is taking longer than expected.';
      root.querySelector('[data-su-provision-actions]').hidden = true;
      root.querySelector('[data-su-verified]').hidden = true;
      root.querySelector('[data-su-delay]').hidden = false;
    }

    function formatNeedBy(value) {
      if (!value) return '—';
      var date = new Date(value + 'T00:00:00');
      return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
    }

    function populateBulkRoute() {
      var fullName = [state.firstName, state.lastName].filter(Boolean).join(' ');
      root.querySelector('[data-su-bulk-contact-name]').textContent = fullName || 'Name';
      root.querySelector('[data-su-bulk-contact-email]').textContent = state.email || 'email@example.org';
      root.querySelector('[data-su-bulk-contact-org]').textContent = state.organizationName || 'Organization';
      root.querySelector('[data-su-bulk-contact-date]').textContent = formatNeedBy(state.needBy);
    }

    function resetBulkSubmission(clearDescription) {
      var confirmation = root.querySelector('[data-su-bulk-submitted]');
      var submitButton = root.querySelector('[data-su-bulk-submit]');
      confirmation.hidden = true;
      submitButton.disabled = false;
      submitButton.firstChild.nodeValue = 'Submit request ';
      if (clearDescription) root.querySelector('[data-su-bulk-description]').value = '';
    }

    function populatePremiumRoute() {
      var fullName = [state.firstName, state.lastName].filter(Boolean).join(' ');
      root.querySelector('[data-su-premium-contact-name]').textContent = fullName || 'Name';
      root.querySelector('[data-su-premium-contact-email]').textContent = state.email || 'email@example.org';
      root.querySelector('[data-su-premium-contact-org]').textContent = state.organizationName || 'Organization';
      root.querySelector('[data-su-premium-contact-date]').textContent = formatNeedBy(state.needBy);
      root.querySelector('[data-su-premium-contact-date-row]').hidden = !state.needBy;
    }

    function populatePremiumReady() {
      root.querySelector('[data-su-premium-ready-org]').textContent = state.organizationName || 'Your organization';
      root.querySelector('[data-su-premium-ready-email]').textContent = state.email || 'The email address you provided';
      root.querySelector('[data-su-premium-ready-purpose]').textContent = purposeLabels[state.purpose] || '—';
      root.querySelector('[data-su-premium-ready-date]').textContent = formatNeedBy(state.needBy);
      root.querySelector('[data-su-premium-ready-date-row]').hidden = !state.needBy;
      root.querySelector('[data-su-premium-ready-reference]').textContent = state.premiumRequestId
        ? state.premiumRequestId.slice(0, 8).toUpperCase()
        : '—';
    }

    function populateReady() {
      var firstName = state.firstName;
      var email = state.email;
      var heading = firstName ? firstName + ', your signup is confirmed.' : 'Your signup is confirmed.';
      var lead = 'We have the information needed to begin setting up your account.';
      var next = email
        ? 'We’ll send account access to ' + email + ' once setup is complete.'
        : 'We’ll send account access to the email address you provided once setup is complete.';

      if (state.plan === 'essential') {
        heading = (firstName ? firstName + ', your' : 'Your') + ' Essential subscription is confirmed.';
        lead = 'Your $20/month Essential subscription is active.';
      } else if (state.plan === 'school') {
        heading = (firstName ? firstName + ', your' : 'Your') + ' Schools & Teams signup is confirmed.';
        lead = 'Your Schools & Teams account has no monthly subscription fee.';
      } else if (state.plan === 'starter') {
        heading = (firstName ? firstName + ', your' : 'Your') + ' Starter signup is confirmed.';
        lead = 'Your Starter account has no monthly subscription fee.';
      }

      root.querySelector('[data-su-ready-heading]').textContent = heading;
      root.querySelector('[data-su-ready-lead]').textContent = lead;
      root.querySelector('[data-su-ready-next]').textContent = next;
      var organization = root.querySelector('[data-su-ready-org]');
      organization.textContent = state.organizationName;
      organization.hidden = !state.organizationName;
      [
        ['[data-su-ready-email]', email],
        ['[data-su-ready-org-size]', organizationSizeLabels[state.organizationSize]],
        ['[data-su-ready-purpose]', purposeLabels[state.purpose]],
        ['[data-su-ready-need-by]', state.needBy ? formatNeedBy(state.needBy) : '']
      ].forEach(function (detail) {
        var field = root.querySelector(detail[0]);
        field.textContent = detail[1] || '';
        field.parentElement.hidden = !detail[1];
      });
      root.querySelector('[data-su-ready-plan]').textContent = planLabels[state.plan] || '';
      root.querySelector('[data-su-ready-reference]').textContent = state.signupRequestId
        ? state.signupRequestId.slice(0, 8).toUpperCase()
        : '—';
    }

    function reportAcceptedSignupToMicrosoft() {
      var signup = pendingMicrosoftSignup;
      if (!signup || !signup.requestId || !hubSpotTrackingAllowed()) return;
      var hostname = window.location.hostname;
      if (hostname !== 'printyourcause.com' && hostname !== 'www.printyourcause.com') return;
      var key = 'pyc-account-signup-microsoft-conversion-v1:' + signup.requestId;
      if (reportedMicrosoftSignups[key]) return;
      try { if (window.localStorage.getItem(key) === 'sent') return; } catch (error) {}
      try {
        window.uetq = window.uetq || [];
        if (typeof window.uetq.push !== 'function') return;
        // No email, name, organization identity, or signup ID is sent to UET.
        window.uetq.push('event', 'sign_up', {
          event_category: 'account_signup_flow',
          event_label: signup.plan
        });
        reportedMicrosoftSignups[key] = true;
        try { window.localStorage.setItem(key, 'sent'); } catch (error) {}
        pendingMicrosoftSignup = null;
      } catch (error) {
        // Advertising measurement must never interrupt signup confirmation.
      }
    }

    function fireSignupConversion() {
      if (!['starter', 'essential', 'school'].includes(state.plan)) return;
      if (state.plan === 'essential' && !state.paymentConfirmed) return;
      if (!state.signupRequestId) state.signupRequestId = createSignupRequestId();

      var conversionKey = 'pyc-account-signup-conversion-v1:' + state.signupRequestId;
      try {
        if (window.localStorage.getItem(conversionKey) === 'sent') return;
      } catch (error) {}

      // Called only on the existing server-confirmed signup/payment paths.
      // Queue separately so consent collected later can release this event.
      pendingMicrosoftSignup = { requestId: state.signupRequestId, plan: state.plan };
      reportAcceptedSignupToMicrosoft();

      var payload = {
        method: 'account_signup_flow',
        plan: state.plan,
        currency: 'USD',
        value: state.plan === 'essential' ? 20 : 0,
        event_id: state.signupRequestId,
        page_path: window.location.pathname
      };

      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'sign_up', payload);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'sign_up' }, payload));
        window.localStorage.setItem(conversionKey, 'sent');
      } catch (error) {
        // Analytics must never interrupt the confirmation screen.
      }
    }

    function firePremiumInquiry() {
      if (!state.premiumRequestId) return;
      var conversionKey = 'pyc-premium-inquiry-conversion-v1:' + state.premiumRequestId;
      try {
        if (window.localStorage.getItem(conversionKey) === 'sent') return;
      } catch (error) {}

      var payload = {
        method: 'account_signup_flow',
        inquiry_type: 'premium',
        event_id: state.premiumRequestId,
        page_path: window.location.pathname
      };

      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'premium_inquiry', payload);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'premium_inquiry' }, payload));
        window.localStorage.setItem(conversionKey, 'sent');
      } catch (error) {
        // Analytics must never interrupt the request confirmation.
      }
    }

    function showPremiumConfirmation() {
      saveState();
      populatePremiumReady();
      showScreen('premium-ready');
      firePremiumInquiry();
    }

    function showSignupConfirmation() {
      if (!state.signupRequestId) state.signupRequestId = createSignupRequestId();
      saveState();
      populateReady();
      showScreen('ready');
      fireSignupConversion();
    }

    function accountSignupPayload() {
      if (!state.signupRequestId) state.signupRequestId = createSignupRequestId();
      return {
        signupRequestId: state.signupRequestId,
        organizationType: state.organizationType,
        organizationName: state.organizationName,
        organizationSize: state.organizationSize,
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        purpose: state.purpose,
        needBy: state.needBy,
        termsAccepted: state.termsAccepted === true,
        plan: state.plan
      };
    }

    function bulkRequestPayload() {
      if (!state.bulkRequestId) state.bulkRequestId = createSignupRequestId();
      return {
        requestId: state.bulkRequestId,
        organizationType: state.organizationType,
        organizationName: state.organizationName,
        organizationSize: state.organizationSize,
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        needBy: state.needBy,
        description: state.bulkDescription,
        termsAccepted: state.termsAccepted === true
      };
    }

    function premiumRequestPayload() {
      if (!state.premiumRequestId) state.premiumRequestId = createSignupRequestId();
      var payload = {
        requestId: state.premiumRequestId,
        organizationType: state.organizationType,
        organizationName: state.organizationName,
        organizationSize: state.organizationSize,
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        purpose: state.purpose,
        description: state.premiumDescription,
        termsAccepted: state.termsAccepted === true
      };
      if (state.needBy) payload.needBy = state.needBy;
      return payload;
    }

    async function readJson(response) {
      try { return await response.json(); } catch (error) { return {}; }
    }

    async function beginEssentialCheckout() {
      var button = root.querySelector('[data-su-pay]');
      var terms = root.querySelector('input[name="checkout_terms"]');
      if (!terms || !terms.checked) {
        if (terms) terms.reportValidity();
        setPaymentStatus('Please accept the Terms of Service and acknowledge the Privacy Policy to continue.', true);
        return;
      }
      state.termsAccepted = true;
      if (!requireCurrentNeedByDate()) return;
      if (!apiBase) {
        setPaymentStatus('The payment service is not configured.', true);
        return;
      }
      button.disabled = true;
      button.firstChild.nodeValue = 'Opening secure checkout ';
      setPaymentStatus(signupEnvironment === 'sandbox' ? 'Creating your Stripe sandbox checkout…' : 'Opening secure Stripe checkout…', false);
      var payload = accountSignupPayload();
      saveState();

      try {
        var response = await window.fetch(apiBase + '/signup/essential/checkout', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var result = await readJson(response);
        if (response.status === 409 && (result.code === 'checkout_expired' || result.state === 'checkout_expired')) {
          state.signupRequestId = createSignupRequestId();
          state.paymentConfirmed = false;
          saveState();
          clearCheckoutReturnParameters();
          setPaymentStatus('That checkout expired without payment. Your information is saved. Select Continue to secure payment again to open a new checkout.', false);
          button.disabled = false;
          button.firstChild.nodeValue = 'Continue to secure payment ';
          return;
        }
        if (!response.ok) {
          throw new Error(result.message || 'Stripe Checkout could not be started.');
        }
        saveState();
        if (result.state === 'paid_confirmed') {
          state.paymentConfirmed = true;
          queueAcceptedSignupForHubSpot(state.signupRequestId);
          showSignupConfirmation();
          return;
        }
        if (!result.checkoutUrl) throw new Error('Stripe did not return a checkout link.');
        queueAcceptedSignupForHubSpot(state.signupRequestId);
        window.location.assign(result.checkoutUrl);
      } catch (error) {
        setPaymentStatus(error && error.message ? error.message : 'Stripe Checkout could not be started.', true);
        button.disabled = false;
        button.firstChild.nodeValue = 'Continue to secure payment ';
      }
    }

    async function submitNoPaymentSignup() {
      var button = root.querySelector('[data-su-plan-continue]');
      if (!requireCurrentNeedByDate()) return;
      if (!apiBase) {
        setSignupStatus('The account signup service is not configured.', true);
        return;
      }
      button.disabled = true;
      button.firstChild.nodeValue = 'Confirming signup ';
      setSignupStatus('Confirming your account signup…', false);
      var payload = accountSignupPayload();
      saveState();
      try {
        var response = await window.fetch(apiBase + '/signup/account', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var result = await readJson(response);
        if (!response.ok || result.state !== 'signup_confirmed') {
          throw new Error(result.message || 'Your account signup could not be confirmed.');
        }
        setSignupStatus('', false);
        queueAcceptedSignupForHubSpot(state.signupRequestId);
        showSignupConfirmation();
      } catch (error) {
        setSignupStatus(error && error.message ? error.message : 'Your account signup could not be confirmed.', true);
      } finally {
        button.disabled = false;
        button.firstChild.nodeValue = state.plan === 'essential' ? 'Continue to payment ' : 'Confirm signup ';
      }
    }

    async function submitBulkRequest(form) {
      var button = root.querySelector('[data-su-bulk-submit]');
      if (!requireCurrentNeedByDate()) return;
      state.bulkDescription = form.elements.bulk_description.value.trim();
      state.termsAccepted = form.elements.bulk_terms.checked;
      if (!apiBase) {
        setSignupStatus('The request service is not configured.', true);
        return;
      }
      button.disabled = true;
      button.firstChild.nodeValue = 'Submitting request ';
      setSignupStatus('Submitting your request…', false);
      var payload = bulkRequestPayload();
      saveState();
      try {
        var response = await window.fetch(apiBase + '/signup/bulk', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var result = await readJson(response);
        if (!response.ok || result.state !== 'request_confirmed') {
          throw new Error(result.message || 'Your request could not be submitted.');
        }
        setSignupStatus('', false);
        queueAcceptedSignupForHubSpot(state.bulkRequestId);
        root.querySelector('[data-su-bulk-submitted]').hidden = false;
        button.firstChild.nodeValue = 'Request submitted ';
      } catch (error) {
        setSignupStatus(error && error.message ? error.message : 'Your request could not be submitted.', true);
        button.disabled = false;
        button.firstChild.nodeValue = 'Submit request ';
      }
    }

    async function submitPremiumRequest(form) {
      var button = root.querySelector('[data-su-premium-submit]');
      if (!requireCurrentNeedByDate()) return;
      state.premiumDescription = form.elements.premium_description.value.trim();
      state.termsAccepted = form.elements.premium_terms.checked;
      if (!apiBase) {
        setPremiumStatus('The request service is not configured.', true);
        return;
      }
      button.disabled = true;
      button.firstChild.nodeValue = 'Submitting request ';
      setPremiumStatus('Submitting your Premium request…', false);
      var payload = premiumRequestPayload();
      saveState();
      try {
        var response = await window.fetch(apiBase + '/signup/premium', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var result = await readJson(response);
        if (!response.ok || result.state !== 'request_confirmed') {
          throw new Error(result.message || 'Your Premium request could not be submitted.');
        }
        setPremiumStatus('', false);
        queueAcceptedSignupForHubSpot(state.premiumRequestId);
        showPremiumConfirmation();
      } catch (error) {
        setPremiumStatus(error && error.message ? error.message : 'Your Premium request could not be submitted.', true);
        button.disabled = false;
        button.firstChild.nodeValue = 'Request a Premium consultation ';
      }
    }

    async function pollEssentialStatus(attemptId) {
      var attempts = 0;
      setPaymentStatus('Payment received. Waiting for Stripe to confirm it securely…', false);

      async function poll() {
        attempts += 1;
        try {
          var response = await window.fetch(
            apiBase + '/signup/essential/status?attempt_id=' + encodeURIComponent(attemptId),
            { headers: { accept: 'application/json' }, cache: 'no-store' }
          );
          var result = await readJson(response);
          if (!response.ok) throw new Error(result.message || 'Payment status could not be checked.');
          if (result.state === 'paid_confirmed' && result.provisioningAllowed === true) {
            state.paymentConfirmed = true;
            showSignupConfirmation();
            return;
          }
          if (result.state === 'payment_failed' || result.state === 'needs_attention') {
            setPaymentStatus('Stripe could not confirm this payment. Please try again or choose another payment method.', true);
            return;
          }
          if (attempts < 40) {
            timers.push(window.setTimeout(poll, 1500));
          } else {
            setPaymentStatus('Stripe is still confirming the payment. Refresh this page in a moment; no second payment is needed.', false);
          }
        } catch (error) {
          if (attempts < 40) {
            timers.push(window.setTimeout(poll, 1500));
          } else {
            setPaymentStatus(error && error.message ? error.message : 'Payment status could not be checked.', true);
          }
        }
      }

      await poll();
    }

    function applyCheckoutReturn() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (error) { return false; }
      var result = params.get('essential_checkout');
      var attemptId = params.get('attempt_id');
      if (!result || !attemptId) return false;

      var hasSavedSignup = restoreState(attemptId);
      if (hasSavedSignup) restoreFormFieldsFromState();
      configurePlans();
      state.signupRequestId = attemptId;
      state.plan = 'essential';
      var checkoutTerms = root.querySelector('input[name="checkout_terms"]');
      if (checkoutTerms) checkoutTerms.checked = state.termsAccepted === true;
      var checkoutOrganization = root.querySelector('[data-su-checkout-org]');
      var checkoutEmail = root.querySelector('[data-su-checkout-email]');
      checkoutOrganization.textContent = state.organizationName;
      checkoutOrganization.parentElement.hidden = !state.organizationName;
      checkoutEmail.textContent = state.email;
      checkoutEmail.parentElement.hidden = !state.email;
      setPlan('essential');
      showScreen('checkout', true);

      if (result === 'cancelled') {
        setPaymentStatus('Checkout was canceled. Nothing was charged; you can continue whenever you are ready.', false);
        return true;
      }
      if (result === 'success') {
        void pollEssentialStatus(attemptId);
        return true;
      }
      return true;
    }

    function restoreFormFieldsFromState() {
      var values = {
        organization_name: state.organizationName,
        organization_size: state.organizationSize,
        first_name: state.firstName,
        last_name: state.lastName,
        email: state.email,
        need_by: state.needBy,
        bulk_description: state.bulkDescription,
        premium_description: state.premiumDescription
      };
      Object.keys(values).forEach(function (name) {
        var field = root.querySelector('[name="' + name + '"]');
        if (field) field.value = values[name] || '';
      });
      ['organization_type', 'purpose', 'plan'].forEach(function (name) {
        var field = root.querySelector('[name="' + name + '"][value="' +
          (name === 'organization_type' ? state.organizationType : name === 'purpose' ? state.purpose : state.plan) + '"]');
        if (field) field.checked = true;
      });
    }

    function clearCheckoutReturnParameters() {
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('essential_checkout');
        cleanUrl.searchParams.delete('attempt_id');
        cleanUrl.searchParams.delete('session_id');
        window.history.replaceState({}, '', cleanUrl.toString());
      } catch (error) {}
    }

    function applyExistingSubscriptionRedirect() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (error) { return false; }
      var existing = params.get('existing_subscription');
      if (existing !== '1' && existing !== 'true') return false;

      clearSavedState();
      root.classList.add('is-existing-essential');
      root.querySelector('[data-su-sidebar-eyebrow]').textContent = 'Account access';
      root.querySelector('[data-su-sidebar-heading]').textContent = 'Welcome back.';
      root.querySelector('[data-su-sidebar-copy]').textContent = 'Your Essential subscription is already active.';
      showScreen('existing-essential', true);
      return true;
    }

    root.querySelector('[data-su-form="organization"]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!event.currentTarget.reportValidity()) return;
      state.organizationType = checkedValue(event.currentTarget, 'organization_type');
      state.organizationName = event.currentTarget.elements.organization_name.value.trim();
      state.organizationSize = event.currentTarget.elements.organization_size.value;
      configurePlans();
      showScreen('administrator');
    });

    root.querySelector('[data-su-form="administrator"]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!event.currentTarget.reportValidity()) return;
      state.firstName = event.currentTarget.elements.first_name.value.trim();
      state.lastName = event.currentTarget.elements.last_name.value.trim();
      state.email = event.currentTarget.elements.email.value.trim();
      showScreen('program');
    });

    root.querySelector('[data-su-form="program"]').addEventListener('submit', function (event) {
      event.preventDefault();
      configureNeedByDate(false);
      if (!event.currentTarget.reportValidity()) return;
      state.purpose = checkedValue(event.currentTarget, 'purpose');
      state.needBy = event.currentTarget.elements.need_by.value;
      if (state.premiumIntent) {
        populatePremiumRoute();
        showScreen('premium');
        return;
      }
      if (state.purpose === 'event_bulk') {
        populateBulkRoute();
        resetBulkSubmission(false);
        showScreen('bulk');
        return;
      }
      configurePlans();
      showScreen('plan');
    });

    root.querySelector('[data-su-form="bulk"]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!event.currentTarget.reportValidity()) return;
      void submitBulkRequest(event.currentTarget);
    });

    root.querySelector('[data-su-form="premium"]').addEventListener('submit', function (event) {
      event.preventDefault();
      var description = event.currentTarget.elements.premium_description;
      description.setCustomValidity(description.value.trim().length < 3 ? 'Please describe your plans in at least three characters.' : '');
      if (!event.currentTarget.reportValidity()) return;
      void submitPremiumRequest(event.currentTarget);
    });
    root.querySelector('[data-su-premium-description]').addEventListener('input', function (event) {
      event.currentTarget.setCustomValidity('');
    });

    root.querySelector('[data-su-form="plan"]').addEventListener('submit', function (event) {
      event.preventDefault();
      state.plan = checkedValue(event.currentTarget, 'plan');
      setPlan(state.plan);
      if (!event.currentTarget.reportValidity()) return;
      if (state.plan === 'essential') {
        root.querySelector('[data-su-checkout-org]').textContent = state.organizationName;
        root.querySelector('[data-su-checkout-email]').textContent = state.email;
        showScreen('checkout');
      } else {
        state.termsAccepted = event.currentTarget.elements.plan_terms.checked;
        state.paymentConfirmed = false;
        void submitNoPaymentSignup();
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.name === 'plan') setPlan(event.target.value);
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-su-back]'), function (button) {
      button.addEventListener('click', function () { showScreen(button.dataset.suBack); });
    });

    root.querySelector('[data-su-cancel-checkout]').addEventListener('click', function () { showScreen('plan'); });
    root.querySelector('[data-su-bulk-store]').addEventListener('click', function () {
      configurePlans();
      showScreen('plan');
    });
    root.querySelector('[data-su-premium-from-plan]').addEventListener('click', function () {
      setPremiumIntent(true);
      populatePremiumRoute();
      showScreen('premium');
    });
    root.querySelector('[data-su-premium-self-serve]').addEventListener('click', function () {
      setPremiumIntent(false);
      showScreen('program');
    });
    root.querySelector('[data-su-pay]').addEventListener('click', function () {
      void beginEssentialCheckout();
    });
    root.querySelector('[data-su-run]').addEventListener('click', runProvisioning);
    root.querySelector('[data-su-show-delay]').addEventListener('click', showDelay);
    root.querySelector('[data-su-resume]').addEventListener('click', function () {
      root.querySelector('[data-su-delay]').hidden = true;
      runProvisioning();
    });
    root.querySelector('[data-su-open-workspace]').addEventListener('click', function () {
      populateReady();
      showScreen('ready');
    });
    var resetButton = root.querySelector('[data-su-reset]');
    if (resetButton) resetButton.addEventListener('click', function () {
      clearTimers();
      Array.prototype.forEach.call(root.querySelectorAll('form'), function (form) { form.reset(); });
      state.signupRequestId = '';
      state.bulkRequestId = '';
      state.premiumRequestId = '';
      state.organizationType = '';
      state.organizationName = '';
      state.organizationSize = '';
      state.firstName = '';
      state.lastName = '';
      state.email = '';
      state.purpose = '';
      state.needBy = '';
      state.bulkDescription = '';
      state.premiumDescription = '';
      state.premiumIntent = false;
      state.plan = 'starter';
      state.termsAccepted = false;
      state.paymentConfirmed = false;
      state.provisionStage = 0;
      clearSavedState();
      var checkoutTerms = root.querySelector('input[name="checkout_terms"]');
      if (checkoutTerms) checkoutTerms.checked = false;
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('existing_subscription');
        window.history.replaceState({}, '', cleanUrl.toString());
      } catch (error) {}
      clearCheckoutReturnParameters();
      resetBulkSubmission(true);
      setPremiumStatus('', false);
      shuffleChoiceSets();
      configureNeedByDate(true);
      applyInboundIntent();
      configurePlans();
      showScreen('organization');
    });

    shuffleChoiceSets();
    loadTrackingPermissions();
    configureNeedByDate(true);
    applyInboundIntent();
    configurePlans();
    if (!applyExistingSubscriptionRedirect() && !applyCheckoutReturn()) showScreen('organization', true);
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pyc-signup]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
